import { yupResolver } from "@hookform/resolvers/yup";
import { number, object, string } from "yup";

const schema = object({
  fmcCentsAmount: number().required("FM Coins is required"),
  note: string().trim().required("Note is required"),
  purpose: string().trim().required("Purpose is required"),
}).required();

export const resolver = yupResolver(schema);
